import FindAgentBlock from '../components/FindAgentBlock';
import CommonQuestions from '../components/CommonQuestions/CommonQuestions';
import pdfForm from '../assets/docs/claims/Property_Loss_Inventory_Worksheet.pdf';
import xlsForm from '../assets/docs/claims/HOinventory_form.xlsx';
import ProgressiveImg from '../components/ProgressiveImg';
import { Link } from 'react-router-dom'
import '../assets/styles/pages/_claims-page.scss'
import React, {useEffect, useState} from "react";
import Slider from "react-slick";
import parser from "html-react-parser";
import {useDispatch, useSelector} from "react-redux";
import questionsActions from "../store/actions/questions";
import paymentActions from "../store/actions/payment";

export const Claims = () => {
  const cardsBlock = [
    {
      id: 0,
      title: 'Tell us what happened',
      description: 'Gather as many details as possible about your loss, and file a claim. If necessary, protect your property from further damage.'
    },
    {
      id: 3,
      title: 'Have your property repaired',
      description: 'Select a contractor of your choice to repair or replace your property.'
    },
    {
      id: 1,
      title: 'Have the damage reviewed',
      description: 'A Claims Adjuster will review your claim, assess the damage to your property, and estimate the cost to repair or replace it.'
    },
    {
      id: 4,
      title: 'Finalize your claim',
      description: 'We will issue payment based on the terms of your policy.'
    },
    {
      id: 2,
      title: 'Receive estimate',
      description: 'We will explain your policy coverages and deductibles and will provide a detailed damage estimate.'
    },
  ]
  const cards = [
    {
      id: 0,
      title: 'Stay safe',
      text: 'If your property has sustained extensive damage, do not go back inside until cleared to do so by emergency personnel or local officials, even if the damage is confined to one room.',
      img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/claims/1home.svg`
    },
    {
      id: 1,
      title: 'Keep in touch',
      text: 'Be sure to provide details of where you may be reached, especially if your home is uninhabitable.',
      img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/claims/2phone.svg`

    },
    {
      id: 2,
      title: 'Damage details',
      text: 'Provide as many details as you can about the damage to, or loss of, your property.  If able, take photos of the damage as soon as possible.',
      img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/claims/3papers.svg`


    },
    {
      id: 3,
      title: 'Save your receipts',
      text: 'If you make any necessary, temporary repairs or have other claim-related expenses, be sure to save your receipts. This will assist with reimbursement of covered expenses.',
      img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/claims/4dollar.svg`
    },
    {
      id: 4,
      title: 'Take inventory',
      text: 'If your personal property was damaged or stolen, completing the Personal Property Inventory form will speed up the settlement process.',
      img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/claims/5list.svg`,
      href: pdfForm,
      download: 'DOWNLOAD THE PDF FORM',
      href2: xlsForm,
      download2: 'DOWNLOAD THE XLSX FORM'
    },
  ]
  const questionsStore = useSelector((store) => store.questionsStore);
  const dispatch = useDispatch();

  const [windowWidth, setWindowWidth] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);

  const toggleOpen = (item) => {
    if (item.parentNode.classList.contains('open')){
      item.parentNode.classList.remove('open');
    } else {
      item.parentNode.classList.add('open');
    }
  }

  let resizeWindow = () => {
    setWindowWidth(window.innerWidth);
  };

  const settings = {
    dots: true,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      },
    ]
  };

  const openModal = () => {
    setModalOpen(true);
    document.getElementsByTagName('body')[0].classList.add('modal-open');
  }
  const closeModal = () => {
    setModalOpen(false)
    document.getElementsByTagName('body')[0].classList.remove('modal-open');
  }
  const legacyPortalUrl = process.env.REACT_APP_SIGN_IN_URI || 'https://my.rvos.com/sign/in';
  const goReportPage = () => {
    window.open(legacyPortalUrl, '_blank', 'noopener,noreferrer');
    closeModal();
  }

  useEffect(() => {
    dispatch(questionsActions.fetchQuestions('common', 'CLAIMS'));
    resizeWindow();
    window.addEventListener("resize", resizeWindow);
    return () => window.removeEventListener("resize", resizeWindow);

  }, []);

  return (
      <>
        <div className="claims-page">
          {/* <a href="MyRVOS.com" target="_blank">MyRVOS.com</a> */}
          <div className="claims-block-1">
            <ProgressiveImg
                lowQualitySrc={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/claims/first-block-right.png`}
                highQualitySrc={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/claims/first-block-right.svg`}
                className="right-picture"
            />
            <ProgressiveImg
                lowQualitySrc={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/claims/first-block-left.png`}
                highQualitySrc={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/claims/first-block-left.svg`}
                className="left-picture"
            />
            <div className="container">
              <div
                  className="title"
              >
                Claims Center
              </div>
              <div
                  className="undertitle"
              >
                Whether it's a minor accident or a major disaster, we know it can be a very stressful time. Our goal is to help you get back on track quickly. We have made filing a claim online fast and easy and will walk you through the process from start to finish.
              </div>
              <button
                  className='action-btn button-gradient'
                  onClick={openModal}
              >
                Report or View a Claim
              </button>
              <img className="image-mobile" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/claims/claims-main-mob.png`} alt="claim adjuster with umbrella over insured in the rain"/>
            </div>
          </div>

          <div className="claims-block-2">
            <div className="container">
              <div className="title">
                How do I file a claim?
              </div>
              <div className="subtitle">
                Report a claim quickly and easily
              </div>
              <div className="cards-block">
                <div className="card">
                  <div className="card-image">
                    <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/claims/pic1.svg`} alt="use a smart device to report a claim online" />
                  </div>
                  <div className="card-title">
                    Report a claim online
                  </div>
                  <div className="card-description">
                    You can file your claim online at any time or
                    check the status of an existing claim using <a href={legacyPortalUrl} target="_blank" rel="noopener noreferrer">MyRVOS</a> .
                  </div>
                </div>
                <div className="card">
                  <div className="card-image">
                    <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/claims/pic2.svg`} alt="insured contacting an agent" />
                  </div>
                  <div className="card-title">
                    Contact your agent
                  </div>
                  <div className="card-description">
                    <Link to="/find-an-agent">
                      Your agent
                    </Link> can assist you in filing a claim.
                  </div>
                </div>
                <div className="card">
                  <div className="card-image">
                    <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/claims/pic3.svg`} alt="customer service representative" />
                  </div>
                  <div className="card-title">
                    Call RVOS Insurance
                  </div>
                  <div className="card-description">
                    File a claim by calling us directly at <span className="nowrap"><a href="tel:18007923084">1-800-792-3084</a></span>.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="claims-block-3">
            <div className="container">
              <div className="title">
                Understanding the claims process
              </div>
              <div className="cards-block">
                <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/claims/pic4.svg`} alt="" />
                {
                  cardsBlock.map(item => {
                    return (
                        <div className="card" key={item.id} >
                          <div className="left-block">
                            {item.id + 1}
                          </div>
                          <div className="right-block">
                            <div className="title">
                              {item.title}
                            </div>
                            <div className="description">
                              {item.description}
                            </div>
                          </div>
                        </div>
                    )
                  })
                }
              </div>
            </div>
          </div>

          <div className="claims-block-4">
            <div className="container">
              <div className="baba">
                <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/claims/pic5.svg`} alt="" />
              </div>
              <div className="title">
                If you have experienced a loss
              </div>
              <div className="undertitle">
                A few tips to help you get reimbursed for your expenses
              </div>
              {windowWidth < 1024 ? (
                  <Slider className="cards-block-slider" {...settings}>
                    {
                      cards.map(item => {
                        return <div className="card-wrapper" key={item.id}>
                          <div className="card" key={item.id}>
                            <div className='top-line'>
                              <div className="top-line__image">
                                <img src={item.img} alt="" />
                              </div>
                              <span>{item.title}</span>
                            </div>
                            <div className='text'>
                              {item.text}
                            </div>
                            <ul className="attachments">
                              {item?.href && <li><a
                                  href={item.href}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="download">
                                {item.download}
                              </a></li>}
                              {item?.href2 && <li><a
                                  href={item.href2}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="download">
                                {item.download2}
                              </a></li>}
                            </ul>
                            <div className="left-border"/>
                          </div>
                        </div>

                      })
                    }
                  </Slider>
              ) : (
                  <div className="cards-block">
                    {
                      cards.map(item => {
                        return <div className="card-wrapper" key={item.id}>
                          <div className="card" key={item.id}>
                            <div className='top-line'>
                              <div className="top-line__image">
                                <img src={item.img} alt="" />
                              </div>
                              <span>{item.title}</span>
                            </div>
                            <div className='text'>
                              {item.text}
                            </div>
                            <ul className="attachments">
                              {item?.href && <li><a
                                  href={item.href}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="download">
                                {item.download}
                              </a></li>}
                              {item?.href2 && <li><a
                                  href={item.href2}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="download">
                                {item.download2}
                              </a></li>}
                            </ul>
                            <div className="left-border"/>
                          </div>
                        </div>

                      })
                    }
                  </div>
              )}

            </div>
          </div>

          <div className="common-questions claims-block-5">
            <div className="container">
              <div className={`title ${questionsStore.commonQuestionsList.length > 0 ? '' : 'hidden'}`}>Common Questions</div>
              {
                questionsStore.commonQuestionsList.map(item => {
                  return <ul className='question-block' key={item.id}>
                    <li className='question-line' onClick={(ev) => toggleOpen(ev.target)}>
                      <div>
                        <div className="question">
                          <div className="number">{questionsStore.commonQuestionsList.indexOf(item) + 1}</div>
                          {item.question}
                        </div>
                      </div>
                      <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/arrow-dropdown.png`} alt="" className={`arrow ${ item.isOpened ? 'turned' : '' }`} />
                    </li>
                    <li
                        className={`answer-line ${item.isOpened ? 'opened' : '' }`}
                    >
                      <div className="answer">
                        {parser(item.answer)}
                      </div>
                    </li>
                  </ul>
                })
              }
              <div className="common-questions-text-link">
                Still have a question? Visit our <Link to="/info-center">Info Center</Link>
              </div>
            </div>
          </div>
          <FindAgentBlock />
          {modalOpen && (
              <div className="modal modal-claims">
                <div className="modal-block">
                  <button
                      type='button'
                      className='modal-close'
                      onClick={closeModal}
                  >
                    <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/find-an-agent/close.svg`} alt="close"/>
                  </button>
                  <div className="modal-content">
                    <img className="modal-decor" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/claims/claims-modal-decor.svg`} alt="modal-decor"/>
                    <div className="modal-text">
                      You are being transferred to the MyRVOS customer portal where you can enter a claim as well as other activities.
                    </div>
                  <a className='form-submit button-gradient' href={legacyPortalUrl} target="_blank" rel="noopener noreferrer" onClick={closeModal}>Continue</a>
                  </div>
                </div>
                <div className="modal-overlay" onClick={closeModal} />
              </div>
          )}
        </div>
      </>
  );
}
